import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from 'store';

type Props = {
  overlayClass?: string;
};

const StickyHeader: React.FC<Props> = (props) => {
  const stickyOverlay = useSelector((state: RootState) => state.uiReducer.stickyOverlay);
  const backOverlayOnStickyHeader = useSelector((state: RootState) => state.uiReducer.backOverlayOnStickyHeader);

  useEffect(() => {
    let body = document.querySelector('body');
    if (stickyOverlay) {
      body && body.classList.add('overlay-sticky');
    } else {
      body && body.classList.remove('overlay-sticky');
    }
  }, [stickyOverlay]);

  return (
    <StickyHeaderContainer id="sticky-header" className={`sticky-header ${props.overlayClass}`}>
      {props?.children}
      {backOverlayOnStickyHeader ? <div className="black-overlay" /> : null}
    </StickyHeaderContainer>
  );
};

export default StickyHeader;

const StickyHeaderContainer = styled.div`
  background-color: #ffffff;
  height: 120px;
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 0px 40px 0px 150px;
  box-shadow: 0px 0px 30px 2px rgb(0 0 0 / 20%);
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 0px 30px 0px 126px;
    height: 90px;
  }

  .black-overlay {
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.6;
    position: absolute;
    left: 0;
  }

  &.sticky-header.asset-header {
    /* z-index: 13; */
    &.header-truncate-remove {
      .label-container {
        #editable-name-wrapper:not(.isDigestArea) {
          .email-name {
            max-width: calc(100vw - 600px) !important;
            @media all and (max-width: 1445px) {
              max-width: calc(100vw - 600px) !important;
            }
            @media all and (min-width: 1900px) {
              max-width: calc(100vw - 750px) !important;
            }
          }
        }
        #editable-name-wrapper {
          &.isDigestArea {
            .email-name {
              max-width: calc(100vw - 1120px) !important;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                max-width: calc(100vw - 945px) !important;
              }
            }
          }
        }
      }
    }
    .template-panel.open,
    .new-asset-wrapper.open,
    .campaign-asider.open {
      &:before {
        content: '';
        width: 5000px;
        /* height: 120px; */
        height: 100vh;
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
        transition: 0.5s;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          /* height: 90px; */
        }
      }
      .expandable {
        z-index: 10;
        position: relative;
      }
    }
    .list-view,
    .card-view {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        /* height: 27px; */
      }
    }
    .bottom-margin svg {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 16px;
      }
    }
    .small-label {
      font-size: 12px !important;
    }
    .email-name {
      font-size: 30px !important;
      line-height: 46px !important;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 21px !important;
        line-height: 33px !important;
      }
    }
    .edit-margin-top {
      line-height: 36px !important;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 28px !important;
      }
    }
    button {
      .label,
      .wrapper {
        word-break: break-all;
        white-space: nowrap;
      }
    }
    .label-container {
      max-width: calc(100% - 870px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: calc(100% - 740px);
      }
      @media all and (max-width: 1100px) {
        max-width: calc(100% - 685px);
      }
    }
  }
  button {
    white-space: nowrap;
    &.send-clone {
      height: 42px;
      padding: 0 5px 0 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 34px;
      }
    }
    &.clone-edit-btn {
      border: 1px solid #27ce0a;
      color: #27ce0a;
    }
    &.clone-edit-btn:hover {
      color: #fff;
    }
  }
  .tabs-justified-center {
    button {
      white-space: nowrap;
    }
    .button-and-search-icon {
      padding: 2px 0 0 10px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding-top: 5px;
      }
    }
  }
  .email-name-box {
    .name-container {
      margin-top: -3px;
    }
  }
`;
